/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react'
import { detectIEEdge } from '@fil-global/gds-components/scripts/util/util'
import _ from 'lodash'

import { getGlobalParams, getCustomIntl } from 'config/config'
import { updateBreadCrumb, updateHtmlTitle, handleComparisonItems } from 'utils/interaction'
import { dispatchFundPage } from 'utils/tracking'

import Link from '../../../atoms/Link'
import FundsWatchList from '../../../templates/FundsWatchList'
import { getFundList } from '../services'
import columns from '../FundsList/columns'

import './style.scss'

const TWFundsWatchList = () => {
  const { favListName, fundComparisonCart, funds2CartJob, cart2FundJob, hasFundComparison, comparisonLimit } = getGlobalParams()

  const intl = getCustomIntl()
  const favItems = localStorage.getItem(favListName) ? JSON.parse(localStorage.getItem(favListName)) : []
  const [watchListTableData, setWatchListTableData] = useState()

  const watchListTableDataRef = useRef(watchListTableData)

  const setWatchListTableDataRef = (x) => {
    watchListTableDataRef.current = x
    setWatchListTableData(x)
  }

  const updateComparisonStatus = (shareClassInfo) => {
    handleComparisonItems(shareClassInfo)

    setWatchListTableDataRef({
      ...watchListTableDataRef.current,
      columns: columns({ handleComparisonItems: updateComparisonStatus })
    })
  }

  useEffect(async () => {
    // Call Django function to update breadcrumb
    updateBreadCrumb(intl.formatMessage({ id: 'fundWatchlist.title' }))
    updateHtmlTitle(intl.formatMessage({ id: 'fundWatchlist.title' }))
    dispatchFundPage()

    if (favItems.length) {
      const fullFundsList = await getFundList()
      const favFundsList = fullFundsList.filter((fund) => {
        return favItems.includes(fund.shareClassId)
      })

      // remove default group in watchlist
      // const newWatchlistRule = _.set(_.cloneDeep(rule), 'group.parameters.key', 'none')

      // let watchlistData = []
      // const formattedFilteredTableData = mergeBy(filteredFundList, newWatchlistRule, terms)

      // if (filteredFundList.length) {
      //   const { modifiedTableData } = toggleIconStatus({
      //     tableData: formattedFilteredTableData,
      //     cellIndex: 1,
      //     cellItemIndex: 1,
      //     storageKey: 'favListName'
      //   })
      //   watchlistData = modifiedTableData
      // } else {
      //   const copiedFormattedFilteredTableData = JSON.parse(JSON.stringify(formattedFilteredTableData))
      //   copiedFormattedFilteredTableData.body = filteredFundList
      //   watchlistData = copiedFormattedFilteredTableData
      // }

      if (hasFundComparison) {
        const currentItems = sessionStorage.getItem(fundComparisonCart) ? JSON.parse(sessionStorage.getItem(fundComparisonCart)) : []
        funds2CartJob.funds2CartTrigger(currentItems)
        cart2FundJob.cart2FundSubject.subscribe({
          next: () => {
            setWatchListTableDataRef({
              ...watchListTableDataRef.current,
              columns: columns({ handleComparisonItems: updateComparisonStatus })
            })
          }
        })
      }

      setWatchListTableDataRef({
        columns: columns({ handleComparisonItems: updateComparisonStatus }),
        dataSource: favFundsList
      })
    } else {
      setWatchListTableDataRef({
        columns: columns({ handleComparisonItems: updateComparisonStatus }),
        dataSource: []
      })
    }
  }, [])

  return (
    <div className="tw-fil-fund-watchlist">
      <FundsWatchList
        id="tw-watchlist"
        {...{
          watchlistTitle: intl.formatMessage({ id: 'fundWatchlist.title' }),
          watchlistTitleShort: intl.formatMessage({ id: 'fundWatchlist.shortTitle' }),
          watchListTableData: watchListTableDataRef.current,
          tableProps: {
            size: 'small',
            textSize: 'small',
            extraClasses: detectIEEdge() ? 'tw-ie11-table' : '',
            withoutDataPlaceholder: (
              <div>
                <span>{intl.formatMessage({ id: 'fundWatchlist.noDataContent' })}</span>
                <span>
                  <Link
                    extraClasses="tw-fil-fund-watchlist-fund-page-link"
                    value={intl.formatMessage({ id: 'fundWatchlist.goToFundsPage' })}
                    to="/funds"
                  />
                </span>
              </div>
            )
          },
          totalResultConfig: {
            fundsCountInfo: {
              totalFundsCount: favItems.length
            }
          }
        }}
      />
    </div>
  )
}

TWFundsWatchList.propTypes = {}

TWFundsWatchList.defaultProps = {}

export default TWFundsWatchList
